<h4>Add to encumbrance</h4>
<p class="border-b border-grey-lighter mt-2 pb-2 text-sm text-grey-dark">
	Please confirm the following selections to add an encumbrance.
</p>

<div class="mt-5">
	Instrument type: <span class="font-bold ml-5">{{ instrumentType }}</span>
</div>

<div class="mt-5 w-full">
	<app-dropdown
		label="Encumbrance type"
		[itemGroups]="[{ items: encumbranceOptions }]"
		[(ngModel)]="encumbranceTypeLabel"
		(onSelect)="selectEncumbranceType($event)"
	></app-dropdown>
</div>

<div class="w-full">
	<app-radio-group
		*ngIf="fileType === fileTypes.REFINANCE"
		label="Please select one of the following options"
		[items]="encumbranceActionsOptions"
		class="mt-3"
		[(ngModel)]="selectedEncumbranceAction"
	></app-radio-group>
	<app-radio-group
		class="mt-3"
		label="Mortgage Priority"
		type="compact"
		[items]="priorityOptions"
		[(ngModel)]="priority"
	></app-radio-group>
</div>

<div class="mt-3 w-full">
	<app-input
		label="Registration number"
		[(ngModel)]="registrationNumber"
	></app-input>
</div>

<div class="mt-3 w-full">
	<app-date-picker
		label="Registration date"
		[(ngModel)]="registrationDate"
		class="mt-2"
	></app-date-picker>
</div>

<div class="mt-10 flex justify-between">
	<app-button size="small" (click)="close()" btn="tertiary">Cancel</app-button>
	<app-button size="small" (click)="save()">Save</app-button>
</div>
